export type TimiCardItem = {
    key: string;
    name: string;
    front: string;
    back: string;
};

export const timiCards: TimiCardItem[] = [
    { key: "stable", name: "안정티미", front: "/assets/timi-cards/stable_front.png", back: "/assets/timi-cards/stable_back.png" },
    { key: "analysis", name: "분석티미", front: "/assets/timi-cards/analysis_front.png", back: "/assets/timi-cards/analysis_back.png" },
    { key: "insight", name: "통찰티미", front: "/assets/timi-cards/insight_front.png", back: "/assets/timi-cards/insight_back.png" },
    { key: "creative", name: "창의티미", front: "/assets/timi-cards/creative_front.png", back: "/assets/timi-cards/creative_back.png" },
    { key: "positive", name: "긍정티미", front: "/assets/timi-cards/positive_front.png", back: "/assets/timi-cards/positive_back.png" },
    { key: "fusion", name: "융합티미", front: "/assets/timi-cards/fusion_front.png", back: "/assets/timi-cards/fusion_back.png" },
    { key: "active", name: "활동티미", front: "/assets/timi-cards/active_front.png", back: "/assets/timi-cards/active_back.png" },
    { key: "adaptive", name: "적응티미", front: "/assets/timi-cards/adaptive_front.png", back: "/assets/timi-cards/adaptive_back.png" },
    { key: "experiment", name: "실험티미", front: "/assets/timi-cards/experiment_front.png", back: "/assets/timi-cards/experiment_back.png" },
    { key: "perfect", name: "완벽티미", front: "/assets/timi-cards/perfect_front.png", back: "/assets/timi-cards/perfect_back.png" },
    { key: "coordination", name: "조율티미", front: "/assets/timi-cards/coordination_front.png", back: "/assets/timi-cards/coordination_back.png" },
    { key: "sense", name: "감각티미", front: "/assets/timi-cards/sense_front.png", back: "/assets/timi-cards/sense_back.png" },
];
